<template>
  <div class="head" :class="{'isOpacity':isOpacity==true}" :style="{'background':bgColor}">
    <div class="logo">
      <img src="../../assets/img/logo.png" alt="">
      <span :style="{'color':fontColor}">赢链通</span>
    </div>
    <div class="nav">
      <a class="nav-sub" :target="item.blank" :class="item.class" :href="item.url" v-for="(item,index) in navArr" :key="index" :style="{'color':fontColor}">{{item.title}}</a>
    </div>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        navArr:[
          {
            title:'首页',
            url:'/',
            blank:'_self'
          },
          {
            title:'信用',
            url:'/#/credit',
            blank:'_self'
          },
          {
            title:'科技赋能',
            url:'/#/science',
            blank:'_self'
          },
          {
            title:'关于我们',
            url:'/#/about',
            blank:'_self'
          },
          {
            title:'登录',
            url:process.env.NODE_ENV!='production'?'http://192.168.50.151:81/login':'http://platform.ying-link.com/login',
            blank:'_blank'
          },
          {
            title:'免费注册',
            url:process.env.NODE_ENV!='production'?'http://192.168.50.151:81/register':'http://platform.ying-link.com/register',
            class:'current',
            blank:'_blank'
          }
        ],
        scroll:0,
        isOpacity:false
      }
    },
    props:['bgColor','fontColor'],
    methods:{
      changeNavStyle(){
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
        if(this.scroll>59){
          this.isOpacity = true;
        }else{
          this.isOpacity = false;
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        console.log(process.env.NODE_ENV)
        window.addEventListener('scroll', this.changeNavStyle)
      });
    }
  }
</script>
<style lang="less" scoped>
.head{
  width:100%;
  height:59px;
  background:rgba(0,0,0,0);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.0874553);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index:100;
  .logo{
    display: flex;
    align-items: center;
    margin-left:55px;
    img{
      margin-right:8px;
    }
    span{
      font-family: PingFang HK;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      color: #fff;
    }
  }
  .nav{
    height:100%;
    display: flex;
    align-items: center;
    .nav-sub{
      font-family: PingFang HK;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      padding:0 20px;
      height:100%;
      display:flex;
      align-items:center;
    }
    .current{
      background: #3772FF;
      color:#fff;
    }
  }
}
.isOpacity{
  background:rgba(0,0,0,1);
}
</style>